// removed by extract-text-webpack-plugin
module.exports = {"underline":"CwLabel-underline","clickable":"CwLabel-clickable","bold":"CwLabel-bold","italic":"CwLabel-italic","invalid":"CwLabel-invalid","disabled":"CwLabel-disabled","podLabel":"CwLabel-podLabel","link":"CwLabel-link","grey1":"CwLabel-grey1","grey2":"CwLabel-grey2","grey3":"CwLabel-grey3","grey4":"CwLabel-grey4","grey5":"CwLabel-grey5"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwlabel/CwLabel.scss
// module id = 1015
// module chunks = 10